import styled from 'styled-components';

export const ScActionsPanelMobile = styled.div<{
  withTournamentBanner: boolean;
}>`
  position: fixed;
  top: 50px;
  left: 0;

  display: flex;
  flex-direction: column;
  gap: 8px;

  .btn-wrapper {
    position: relative;
    width: 42px;
    height: 100%;
    border-radius: 0px 36px 36px 0px;
    background: ${({ theme }) => theme.grayLightColor};
  }
`;
